import { newsSourceMap } from 'utils';
import t from 'utils/translations';
import { CommonRouterLink } from 'components/common/index';
import * as React from 'react';
import styled from 'styled-components';

interface SocialMediaFeedProps {
    title: string;
    source: string;
    businessIds: string[];
    content: string;
    published: string;
    uri: string;
    modified: string;
}

const BusinessIdList = styled.ul`
    list-style-type: none;
`;

const getShownTitle = (title: string, source: string) => {
    if (source === 'Appointment') {
        return `${t('APPOINTMENT_NEWS')}: ${title}`;
    } else {
        return title;
    }
};

export const ArticleModalElement = ({
    title,
    source,
    businessIds,
    content,
    published,
    uri,
    modified
}: SocialMediaFeedProps) => {
    const shownTitle = getShownTitle(title, source);

    return (
        <div>
            <h1>{shownTitle}</h1>
            <p>{newsSourceMap(source)}</p>
            <p>{published !== '' ? `${t('PUBLISHED')} ${published} ` : ' '}</p>
            <p>{modified !== '' ? `${t('MODIFIED')} ${modified} ` : ' '}</p>
            <div dangerouslySetInnerHTML={{ __html: content }} />
            {uri && uri !== '' && (
                <p>
                    <a href={uri} target="_blank">
                        {t('LINK_TO_ORIGINAL_NEWS_ITEM')}
                    </a>
                </p>
            )}
            <div>
                {t('COMPANIES_AFFILIATED_WITH_THE_PUBLICATION')}
                <BusinessIdList>
                    {businessIds.map((bid: string) => (
                        <li key={bid}>
                            <CommonRouterLink to={`/yritys/${bid}`}>
                                {bid}
                            </CommonRouterLink>
                        </li>
                    ))}
                </BusinessIdList>
            </div>
        </div>
    );
};
